import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Select } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { useSupportFormProductType } from "../../hooks/useSupportFormProductType.js";
import { __ } from "../../utils/i18n.js";
const SupportFormProductTypeField = (param)=>{
    let { forceProduct } = param;
    const productTypes = useSupportFormProductType();
    return /*#__PURE__*/ _jsx(Form.Item, {
        style: {
            display: forceProduct ? "none" : undefined
        },
        label: __("Which product is it about?"),
        name: "product",
        required: true,
        dependencies: [
            "questionType"
        ],
        rules: [
            {
                required: true,
                message: __("Please select a product!")
            },
            (param)=>{
                let { getFieldValue } = param;
                return {
                    validator: ()=>{
                        const questionType = getFieldValue("questionType");
                        const product = getFieldValue("product");
                        return questionType === ESupportTicketQuestionType.RequestCustomOffer && !productTypes[product].licenseHelpArticle ? Promise.reject("This product is not suitable for custom offers. Please select your product.") : Promise.resolve();
                    }
                };
            }
        ],
        children: /*#__PURE__*/ _jsx(Select, {
            children: Object.keys(productTypes).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                    value: productTypes[key]["name"],
                    children: productTypes[key]["localized"]
                }, key))
        })
    });
};
export { SupportFormProductTypeField };
